import uxcelImg from '../assets/images/ed__uxcel.png';
import arielDimlomaImg from '../assets/images/ed__ariel.png';
import vitteDimlomaImg from '../assets/images/Vitte-diploma.jpg';
import bbeImg from '../assets/images/ed__bbe.png';
import awwwardsImg from '../assets/images/ed__awwwards.png';
import practicumProdImg from '../assets/images/ed__practicum-prod.png';
import googleImg from '../assets/images/ed__google.png';
import practicumDesignImg from '../assets/images/ed__practicum-design.png';
import memoriselyImg from '../assets/images/ed__memorisely.png';

export const memoriselyData = {
    title: 'Memorisely',
    date: '2026',
    course: 'AI Coding for designers (Cursor, Claude Code)',
    description: 'Certification',
    image: memoriselyImg,
    document: 'Certificate',
    direction: 'hor',
}

export const uxcelMotionData = {
    title: 'Uxcel',
    date: '2024',
    course: 'UX Design Psychology',
    description: 'Certification',
    image: uxcelImg,
    document: 'Certificate',
    direction: 'hor',
}

export const bbeMotionData = {
    title: 'Bang Bang Education',
    date: '2024 — 2025',
    course: 'Motion Design Specializations (& 3D)',
    description: 'Professional training course',
    image: bbeImg,
    document: 'Certificate',
    direction: 'ver',
}

export const awwwardsData = {
    title: 'Awwwards',
    date: '2024',
    course: 'Using motion design to animate with purpose and create delightful experiences',
    description: 'Masterclass',
    image: awwwardsImg,
    document: 'Certificate',
    direction: 'ver',
}

export const practicumProductData = {
    title: 'Practicum',
    date: '2023',
    course: 'Product approach for designers',
    description: 'Professional training course',
    image: practicumProdImg,
    document: 'Certificate',
    direction: 'hor',

}

export const googleUxData = {
    title: 'Google & Coursera',
    date: '2022',
    course: 'Google UX Design Specialzation',
    description: 'Professional training course',
    image: googleImg,
    document: 'Certificate',
    direction: 'hor',
}

export const practicumUxData = {
    title: 'Practicum',
    date: '2022 – 2023',
    course: 'UX/UI Design',
    description: 'Professional training course',
    image: practicumDesignImg,
    document: 'Certificate',
    direction: 'hor',
}

export const arielData = {
    title: 'Ariel University',
    date: '2021 – 2022',
    course: 'Pre-MBA',
    description: 'Course of studies',
    image: arielDimlomaImg,
    document: 'Diploma',
    direction: 'ver',
}

export const witteData = {
    title: 'Witte University',
    date: '2017 – 2022',
    course: 'Advertising and PR',
    description: 'BA',
    image: vitteDimlomaImg,
    document: 'Diploma',
    direction: 'hor',
}